// extracted by mini-css-extract-plugin
module.exports = {"root":"Text_root__2cSIe","header":"Text_header__25O7b","subheader":"Text_subheader__2peTy"};